import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import Excerpt from './components/Excerpt';
export default function addSummaryExcerpt() {
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (typeof params.include === 'string') {
      params.include = [params.include];
    } else {
      params.include = params.include || [];
    }
    if (app.forum.attribute('synopsis.excerpt_type') === 'first') {
      params.include.push('firstPost');
    } else {
      params.include.push('lastPost');
    }
  });
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    var _app$session$user$pre, _tag, _tag2, _tag3, _tag4, _app$session$user$pre2, _app$session$user, _tag5, _tag6, _tag7, _tag8, _tag9, _tag0;
    const discussion = this.attrs.discussion;
    if (app.session.user && !((_app$session$user$pre = app.session.user.preferences()) != null && _app$session$user$pre.showSynopsisExcerpts)) {
      return;
    }
    const tags = discussion.tags();
    let tag;
    if (tags) {
      tag = tags[tags.length - 1];
    }
    const excerptPost = app.forum.attribute('synopsis.excerpt_type') === 'first' ? discussion.firstPost() : discussion.lastPost();
    const excerptLength = typeof ((_tag = tag) == null ? void 0 : _tag.excerptLength()) === 'number' ? (_tag2 = tag) == null ? void 0 : _tag2.excerptLength() : app.forum.attribute('synopsis.excerpt_length');
    const richExcerpt = typeof ((_tag3 = tag) == null ? void 0 : _tag3.richExcerpts()) === 'boolean' ? (_tag4 = tag) == null ? void 0 : _tag4.richExcerpts() : app.forum.attribute('synopsis.rich_excerpts');
    const onMobile = (_app$session$user$pre2 = (_app$session$user = app.session.user) == null || (_app$session$user = _app$session$user.preferences()) == null ? void 0 : _app$session$user.showSynopsisExcerptsOnMobile) != null ? _app$session$user$pre2 : false;
    const mediaMaxHeight = typeof ((_tag5 = tag) == null ? void 0 : _tag5.excerptMediaMaxHeight()) === 'number' ? (_tag6 = tag) == null ? void 0 : _tag6.excerptMediaMaxHeight() : app.forum.attribute('synopsis.excerpt_media_max_height');
    const videoMaxWidth = typeof ((_tag7 = tag) == null ? void 0 : _tag7.excerptVideoMaxWidth()) === 'number' ? (_tag8 = tag) == null ? void 0 : _tag8.excerptVideoMaxWidth() : app.forum.attribute('synopsis.excerpt_video_max_width');
    const mediaCount = typeof ((_tag9 = tag) == null ? void 0 : _tag9.excerptMediaCount()) === 'number' ? (_tag0 = tag) == null ? void 0 : _tag0.excerptMediaCount() : app.forum.attribute('synopsis.excerpt_media_count');

    // A length of zero means we don't want a synopsis for this discussion, so do nothing.
    if (excerptLength === 0) {
      return;
    }
    if (excerptPost) {
      const excerpt = m(Excerpt, {
        post: excerptPost,
        length: excerptLength,
        richExcerpt: richExcerpt,
        mediaMaxHeight: mediaMaxHeight,
        videoMaxWidth: videoMaxWidth,
        mediaCount: mediaCount
      });
      items.add('excerpt', excerpt, -100);
      onMobile && items.add('excerptM', excerpt, -100);
    }
  });
}